import { render, staticRenderFns } from "./LegalCard.vue?vue&type=template&id=6f7f93b1&scoped=true&"
import script from "./LegalCard.vue?vue&type=script&lang=js&"
export * from "./LegalCard.vue?vue&type=script&lang=js&"
import style0 from "./LegalCard.vue?vue&type=style&index=0&id=6f7f93b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7f93b1",
  null
  
)

export default component.exports